import { SymbolLayerSpecification } from 'mapbox-gl';
import { FONT_SIZE_100 } from '@alltrails/denali/tokens';
import { defaultPOIPinLayerLayoutProps } from '../../../utils/layers';
import { imageNamePrefix as iconPrefix } from '../../../utils/svgDefinitions/createPOIIconPinSvg';
import { imageNamePrefix as photoPrefix } from '../../../utils/svgDefinitions/createPOIPhotoPinSvg';
import { poiPinVerticalOffset } from '../../../utils/svgDefinitions/svgMarkerComponents';

export const defaultPOIPinXSLayoutProps: SymbolLayerSpecification['layout'] = {
  ...defaultPOIPinLayerLayoutProps,
  'icon-image': [
    'case',
    ['==', ['get', 'hasPhotos'], true],
    ['concat', `${photoPrefix}-`, ['get', 'id'], '-xs'],
    ['concat', `${iconPrefix}-`, ['get', 'type'], '-xs']
  ],
  /**
   * https://docs.mapbox.com/style-spec/reference/layers/#layout-symbol-symbol-sort-key
   * NOTE: the way the sort key is calculated gets flipped depending on the value of icon-allow-overlap or text-allow-overlap
   * When false, lower sort keys will have priority.
   * When true, higher sort keys will have priority.
   */
  'symbol-sort-key': ['-', 100, ['get', 'popularity']],
  'text-field': '{name}',
  'text-offset': [0, poiPinVerticalOffset / FONT_SIZE_100],
  'text-size': ['step', ['zoom'], 0, 8, FONT_SIZE_100]
};
